import { type TokenBalanceProps } from '~/components/component-library'

export const EMPTY_VALUE = <span className="text-secondary">-</span>

export const directionForChange = (
  change: number,
): TokenBalanceProps['direction'] => {
  if (change > 0) return 'inflow'
  if (change < 0) return 'outflow'
  return 'neutral'
}
